import React from "react"
import PropTypes from "prop-types"
import { forwardRef } from "@chakra-ui/react"

import { Section } from "../../sections/Section"
import { HeadingOne, TextLG, TextXS } from "../../ui/Typography"
import { ConditionalWrap } from "../../utils/components/ConditionalWrap"

export const PageHeader = forwardRef(
  (
    {
      title,
      lead,
      sublead,
      textAlign = "center",
      maxW = "container.md",
      ...rest
    },
    ref
  ) => (
    <Section ref={ref} maxW={maxW} textAlign={textAlign} as="header" {...rest}>
      <HeadingOne>{title}</HeadingOne>
      {lead && (
        <ConditionalWrap
          condition={typeof lead === "string"}
          wrap={children => (
            <TextLG muted maxW="60ch">
              {children}
            </TextLG>
          )}
        >
          {lead}
        </ConditionalWrap>
      )}

      {sublead && (
        <ConditionalWrap
          condition={typeof sublead === "string"}
          wrap={children => <TextXS muted>{children}</TextXS>}
        >
          {sublead}
        </ConditionalWrap>
      )}
    </Section>
  )
)

PageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  lead: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sublead: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxW: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  textAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}
